import { P } from '../../theme/tokens';
import { DEFAULT_TZ } from './time';

export const AGENT_COLORS = [P.info, P.success, P.purple, P.cyan];

export const UNASSIGNED = { id: 'unassigned', label: 'Unassigned', color: P.warning };

export const TYPE_LABEL = { tour: 'Tour', appointment: 'Appointment', block: 'Blocked time' };

export const STATUS = {
  booked: { label: 'Booked', color: P.info },
  completed: { label: 'Completed', color: P.success },
  cancelled: { label: 'Cancelled', color: P.subtle }
};

export const WEEKDAYS = [
  { day: 1, label: 'Monday' },
  { day: 2, label: 'Tuesday' },
  { day: 3, label: 'Wednesday' },
  { day: 4, label: 'Thursday' },
  { day: 5, label: 'Friday' },
  { day: 6, label: 'Saturday' },
  { day: 0, label: 'Sunday' }
];

export const DURATION_OPTIONS = [15, 20, 30, 45, 60, 90];
export const BUFFER_OPTIONS = [0, 5, 10, 15, 20, 30];

export const withDefaults = (s = {}) => ({
  enabled: Boolean(s.enabled),
  timezone: s.timezone || DEFAULT_TZ,
  slotDurationMin: s.slotDurationMin || 30,
  bufferMin: s.bufferMin || 0,
  leadTimeHours: s.leadTimeHours ?? 2,
  maxAdvanceDays: s.maxAdvanceDays || 14,
  weeklyHours: s.weeklyHours || {}
});

export const minutesLabel = (n) => (n >= 60 && n % 60 === 0 ? `${n / 60} hr${n > 60 ? 's' : ''}` : `${n} min`);
export const hoursLabel = (n) => (n ? `${n} hr${n === 1 ? '' : 's'}` : 'None');
export const daysLabel = (n) => `${n} day${n === 1 ? '' : 's'}`;
